<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">转房</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="roomChangeForm" :rules="rules" ref="roomChangeForm">
                    <div>
                        <div style="color:red;text-align:center;">转房操作会结算之前的入住费用,重新办理入住</div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="入住套餐" required prop="checkinSetmealCode">
                                    <el-select v-model="roomChangeForm.checkinSetmealCode" placeholder="请选择入住套餐" @change="getListBerthValue"  style="width:100%">
                                        <el-option
                                                v-for="item in setmealList"
                                                :key="item.checkinSetmealCode"
                                                :label="item.name"
                                                :value="item.checkinSetmealCode">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item" v-show="roomChangeForm.checkinSetmealCode">
                                <el-form-item label="床号" required prop="berthCode">
                                    <el-cascader
                                        v-model="roomChangeForm.berthCode"
                                        placeholder="请选择床号"
                                        :options="ListBerth" :props="props" style="width:100%"></el-cascader>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" class="item">
                                <el-form-item label="退房时间" required prop="endTimePlan">
                                    <el-date-picker
                                        ref="picker"
                                        v-model="roomChangeForm.endTimePlan"
                                        type="date"
                                        value-format='yyyy-MM-dd'
                                        :clearable='false'
                                        :picker-options="pickerOption"
                                        style="width:100%;margin-right:10px">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <!-- <el-col :span="12" class="item">
                                <el-form-item label="入住类型" required prop="type">
                                    <el-select v-model="roomChangeForm.type" placeholder="请选择入住类型" style="width:100%">
                                        <el-option
                                            v-for="(item,i) in typeValue"
                                            :key="i"
                                            :label="item"
                                            :value="i">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col> -->
                            <el-col :span="18" class="item">
                                <el-form-item label="转房备注" required prop="remarks">
                                    <el-input  placeholder="请输入转房备注" v-model="roomChangeForm.remarks" type="textarea" style="width:100%"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('roomChangeForm')">转房</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";


    export default {
        name: 'RoomChange',
        props:['setmealList'],
        data() {
            return {

                loading: false,
                ListBerth: [],
                typeValue:['正式入住','试住','预约入住'],
                roomTypeValue:['单人间','双人间'],
                datetimerangeValue:'',
                props: {
                    emitPath:false,
                    value: 'value',
                    label: 'label',
                    // 子层级字段名
                    children: 'children'
                },
                roomChangeForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    checkinCode:'',
                    checkinSetmealCode:'',
                    berthCode:'',
                    remarks:'',
                    endTimePlan:'',
                },
                pickerOption: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 8.64e7;
                    },
                },
                rules:{
                    checkinSetmealCode:[
                        { required: true, message: '请选择入住套餐', trigger: 'blur' },
                    ],
                    berthCode:[
                        { required: true, message: '请选择床号', trigger: 'blur' },
                    ],
                    endTimePlan:[
                        { required: true, message: '请选择入住时间', trigger: 'blur' },
                    ],
                    type:[
                        { required: true, message: '请选择入住类型', trigger: 'blur' },
                    ],
                    remarks:[
                        { required: true, message: '请输入转房备注', trigger: 'blur' },
                    ],

                }


            }
        },

        methods: {
            init(row){
                this.loading=false
                this.$refs.roomChangeForm.resetFields();
                this.roomChangeForm.checkinCode=row.checkinCode
            },
            closeSelf() {
                this.$emit("closeRoomChange");
            },

            confirm(roomChangeForm){
                this.$refs[roomChangeForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })

            },
            getListBerthValue(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Berth/ListBerth",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        checkinSetmealCode:this.roomChangeForm.checkinSetmealCode,
                        berthCode:'00000000-0000-0000-0000-000000000000'
                    }
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.roomChangeForm.berthCode=''
                            var datas=response.data.data
                            var JSONData=JSON.stringify(datas);
                            JSONData=JSONData.replace(/listRoomDTO/g,'children');
                            JSONData=JSONData.replace(/listBerth/g,'children');
                            JSONData=JSONData.replace(/name/g,'label');
                            JSONData=JSONData.replace(/number/g,'label');
                            var list=this.getListBerth(JSON.parse(JSONData),0)
                            JSONData=JSON.stringify(list);
                            JSONData=JSONData.replace(/buildingCode/g,'value');
                            JSONData=JSONData.replace(/roomCode/g,'value');
                            JSONData=JSONData.replace(/berthCode/g,'value');
                            this.ListBerth=JSON.parse(JSONData);
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
            getListBerth(list,level){
                for(var i in list){
                    if(level==1){
                        list[i].buildingCode=list[i].roomCode
                    }
                    if(level==2){
                        list[i].roomCode=list[i].berthCode
                    }
                    if(level<2){
                        this.getListBerth(list[i].children,level+1)
                    }
                }
                return list;
            },
            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.roomChangeForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                // this.roomChangeForm.berthCode = this.roomChangeForm.berthCode[2]
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Checkin/RoomChange",
                    data: this.roomChangeForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeRoomChange");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:   0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
